import { FC } from 'react';

type Props = {
  className?: string;
};

export const BorrowMoreColumn1: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="87"
      viewBox="0 0 64 87"
      fill="none"
    >
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H59C61.7614 0 64 2.23858 64 5V83C64 85.7614 61.7614 88 59 88H5C2.23858 88 0 85.7614 0 83V5Z"
        fill="url(#paint0_linear_1312_5500)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1312_5500"
          x1="32"
          y1="-100.32"
          x2="32"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5DD4E8" />
          <stop offset="1" stopColor="#03292E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BorrowMoreColumn2: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="32"
      viewBox="0 0 64 32"
      fill="none"
    >
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H59C61.7614 0 64 2.23858 64 5V52C64 54.7614 61.7614 57 59 57H5C2.23858 57 0 54.7614 0 52V5Z"
        fill="url(#paint0_linear_1312_5501)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1312_5501"
          x1="32"
          y1="-86.3814"
          x2="32"
          y2="57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5DD4E8" />
          <stop offset="1" stopColor="#03292E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
